import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { Skeleton } from '@mui/material';
import Button from '@mui/material/Button';
import { ORG_TYPES, OrgList } from 'fragments';
import { Svg } from 'assets';
import { organizationActions } from 'store';
import { FindLoad } from 'utils';

const ACTION_TYPE = 'GET_BUSINESSES';
export const BusinessNearYou = () => {
    const dispatch = useDispatch();
    const { businesses, orgCategories } = useSelector((state) => state.orgs);
    const [selectedTag, setSelectedTag] = useState('View all');
    const catList = orgCategories?.length ? ['View all', ...orgCategories?.slice(0, 3)] : ['View all'];
    const loader = FindLoad(ACTION_TYPE);

    useEffect(() => {
        dispatch(organizationActions.getOrgCategories());
    }, [dispatch]);


    useEffect(() => {
        const params = {
            limit: 100,
            type: ORG_TYPES.BUSINESS,
        };

        if (selectedTag && selectedTag !== 'View all') {
            params.categories = [selectedTag?.id];
        } else {
            delete params.categories;
        }
        dispatch(organizationActions.getBusinesses(params));
    }, [dispatch, selectedTag]);

    function getTopTenOrgsPrioritizeImages() {
        if (!Array.isArray(businesses?.orgs)) return [];

        const orgsWithImages = [];
        const orgsWithoutImages = [];

        for (const org of businesses.orgs) {
            const hasImage =
                (org?.images?.length && org.images[org.mainImage ?? 0]?.url) ||
                org?.avatar?.url;

            if (hasImage) {
                orgsWithImages.push(org);
            } else {
                orgsWithoutImages.push(org);
            }

            // Early return if we already have 10
            if (orgsWithImages.length === 10) break;
        }

        const combined = orgsWithImages.concat(
            orgsWithoutImages.slice(0, 10 - orgsWithImages.length)
        );

        return combined;
    }

    return (
        <div className="business-near-you-wrapper">
            <div className="business-near-you container">
                <div className="business-near-you-info">
                    <p className="business-near-you-title">
                        Discover Popular Businesses Near You
                    </p>

                    <p className="business-near-you-desc">
                        Discover and support your local Armenian business.
                    </p>
                    <div>
                        <div className="view-all-btn desktop-view">
                            <NavLink to={'/businesses'}>
                                Browse All Organizations
                                <Svg.ArrowUpRight />
                            </NavLink>
                        </div>
                    </div>
                </div>

                <div className="business-near-you-cards">
                    <div className="business-near-you-categories">
                        <div className="tag-tabs-box">
                            {catList?.map((i, j) => (
                                <Button key={j} onClick={() => setSelectedTag(i)}
                                        className={selectedTag === i ? 'active-tab' : 'passive-tab'}>
                                    {i?.text || i}
                                </Button>
                            ))}
                        </div>
                    </div>
                    <div className="business-near-you-organizations">
                        {loader?.length ?
                            <React.Fragment>
                                <Skeleton className="skeleton-card" variant="rectangular" />
                                <Skeleton className="skeleton-card" variant="rectangular" />
                                <Skeleton className="skeleton-card" variant="rectangular" />
                            </React.Fragment>
                            :
                            getTopTenOrgsPrioritizeImages()?.map((i, j) => (
                                <React.Fragment key={j}>
                                    <OrgList viwButton="mapView" org={i} />
                                </React.Fragment>
                            ))}
                    </div>
                </div>

                <div className="flex-end mobile-view">
                    <div className="view-all-btn mobile-view">
                        <NavLink to={'/businesses'}>
                            Browse All Organizations
                            <Svg.ArrowUpRight />
                        </NavLink>
                    </div>
                </div>
            </div>
        </div>
    );
};
